import { config } from "shared/data";

import { AIWidgetApiEndpoint, AIWidgetApiTimeoutMS } from "scmp-app/lib/ai-recommendation/consts";
import { getRecommendParameters } from "scmp-app/lib/ai-recommendation/helpers";
import type { ApiRequestParameters } from "scmp-app/lib/ai-recommendation/types";

import type { TopicYouMayLikeApiResponse } from "./types";

export const fetchArticlePageRecommendation = async (parameters: ApiRequestParameters) => {
  const endpoint = `${AIWidgetApiEndpoint}/article-page`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), AIWidgetApiTimeoutMS);

  const recommendParameters = getRecommendParameters();

  try {
    const reply = await fetch(endpoint, {
      body: JSON.stringify({
        ...parameters,
        recommendParams: recommendParameters,
      }),
      headers: {
        apikey: config.abWidgetApi.apiKey,
        "Content-Type": "application/json",
      },
      method: "POST",
      signal: controller.signal,
    });

    if (!reply.ok) return;
    const { data } = (await reply.json()) as TopicYouMayLikeApiResponse;
    return data;
  } finally {
    clearTimeout(timer);
  }
};
